export default "__VITE_PUBLIC_ASSET__f2087f48__"